
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46all_9332md4N7Z4HMeta } from "/opt/buildhome/repo/pages/[...all].vue?macro=true";
import { default as addressZve8IjYNeeMeta } from "/opt/buildhome/repo/pages/account/address.vue?macro=true";
import { default as indexy4DdxYIhQyMeta } from "/opt/buildhome/repo/pages/account/index.vue?macro=true";
import { default as order7ms7PO2lOOMeta } from "/opt/buildhome/repo/pages/account/order.vue?macro=true";
import { default as paymentbi5OtY86EWMeta } from "/opt/buildhome/repo/pages/account/payment.vue?macro=true";
import { default as profilerpPZ78QyoXMeta } from "/opt/buildhome/repo/pages/account/profile.vue?macro=true";
import { default as indexeImMrR5JSWMeta } from "/opt/buildhome/repo/pages/account/recover/index.vue?macro=true";
import { default as passwordUaQ1P7AJsTMeta } from "/opt/buildhome/repo/pages/account/recover/password.vue?macro=true";
import { default as cartFQ1a8u7wfYMeta } from "/opt/buildhome/repo/pages/checkout/cart.vue?macro=true";
import { default as indexQrPIrenMTVMeta } from "/opt/buildhome/repo/pages/checkout/index.vue?macro=true";
import { default as indexQ8m2dnUYAgMeta } from "/opt/buildhome/repo/pages/checkout/success/[id]/index.vue?macro=true";
import { default as paid8jGiOi7eNuMeta } from "/opt/buildhome/repo/pages/checkout/success/[id]/paid.vue?macro=true";
import { default as unpaidn1vWle8oLeMeta } from "/opt/buildhome/repo/pages/checkout/success/[id]/unpaid.vue?macro=true";
import { default as login4dfr6kRqBoMeta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
import { default as newsletter_45subscribefJTtC9b8woMeta } from "/opt/buildhome/repo/pages/newsletter-subscribe.vue?macro=true";
import { default as registerynsVf0yvMzMeta } from "/opt/buildhome/repo/pages/register.vue?macro=true";
import { default as reset_45passwordR3tuU8TAkoMeta } from "/opt/buildhome/repo/pages/reset-password.vue?macro=true";
import { default as searchW2JMgpGXtYMeta } from "/opt/buildhome/repo/pages/search.vue?macro=true";
import { default as shopwarelllpzpF9RGMeta } from "/opt/buildhome/repo/pages/shopware.vue?macro=true";
import { default as wishlistlzSU18FuZJMeta } from "/opt/buildhome/repo/pages/wishlist.vue?macro=true";
import { default as component_45stubGZr1UkTkg3Meta } from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubGZr1UkTkg3 } from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "all___fr-CH",
    path: "/fr-CH/:all(.*)*",
    component: () => import("/opt/buildhome/repo/pages/[...all].vue")
  },
  {
    name: "all___de-DE",
    path: "/:all(.*)*",
    component: () => import("/opt/buildhome/repo/pages/[...all].vue")
  },
  {
    name: "account-address___fr-CH",
    path: "/fr-CH/account/address",
    meta: addressZve8IjYNeeMeta || {},
    component: () => import("/opt/buildhome/repo/pages/account/address.vue")
  },
  {
    name: "account-address___de-DE",
    path: "/account/address",
    meta: addressZve8IjYNeeMeta || {},
    component: () => import("/opt/buildhome/repo/pages/account/address.vue")
  },
  {
    name: "account___fr-CH",
    path: "/fr-CH/account",
    meta: indexy4DdxYIhQyMeta || {},
    component: () => import("/opt/buildhome/repo/pages/account/index.vue")
  },
  {
    name: "account___de-DE",
    path: "/account",
    meta: indexy4DdxYIhQyMeta || {},
    component: () => import("/opt/buildhome/repo/pages/account/index.vue")
  },
  {
    name: "account-order___fr-CH",
    path: "/fr-CH/account/order",
    meta: order7ms7PO2lOOMeta || {},
    component: () => import("/opt/buildhome/repo/pages/account/order.vue")
  },
  {
    name: "account-order___de-DE",
    path: "/account/order",
    meta: order7ms7PO2lOOMeta || {},
    component: () => import("/opt/buildhome/repo/pages/account/order.vue")
  },
  {
    name: "account-payment___fr-CH",
    path: "/fr-CH/account/payment",
    meta: paymentbi5OtY86EWMeta || {},
    component: () => import("/opt/buildhome/repo/pages/account/payment.vue")
  },
  {
    name: "account-payment___de-DE",
    path: "/account/payment",
    meta: paymentbi5OtY86EWMeta || {},
    component: () => import("/opt/buildhome/repo/pages/account/payment.vue")
  },
  {
    name: "account-profile___fr-CH",
    path: "/fr-CH/account/profile",
    meta: profilerpPZ78QyoXMeta || {},
    component: () => import("/opt/buildhome/repo/pages/account/profile.vue")
  },
  {
    name: "account-profile___de-DE",
    path: "/account/profile",
    meta: profilerpPZ78QyoXMeta || {},
    component: () => import("/opt/buildhome/repo/pages/account/profile.vue")
  },
  {
    name: "account-recover___fr-CH",
    path: "/fr-CH/account/recover",
    component: () => import("/opt/buildhome/repo/pages/account/recover/index.vue")
  },
  {
    name: "account-recover___de-DE",
    path: "/account/recover",
    component: () => import("/opt/buildhome/repo/pages/account/recover/index.vue")
  },
  {
    name: "account-recover-password___fr-CH",
    path: "/fr-CH/account/recover/password",
    component: () => import("/opt/buildhome/repo/pages/account/recover/password.vue")
  },
  {
    name: "account-recover-password___de-DE",
    path: "/account/recover/password",
    component: () => import("/opt/buildhome/repo/pages/account/recover/password.vue")
  },
  {
    name: "checkout-cart___fr-CH",
    path: "/fr-CH/checkout/cart",
    component: () => import("/opt/buildhome/repo/pages/checkout/cart.vue")
  },
  {
    name: "checkout-cart___de-DE",
    path: "/checkout/cart",
    component: () => import("/opt/buildhome/repo/pages/checkout/cart.vue")
  },
  {
    name: "checkout___fr-CH",
    path: "/fr-CH/checkout",
    meta: indexQrPIrenMTVMeta || {},
    component: () => import("/opt/buildhome/repo/pages/checkout/index.vue")
  },
  {
    name: "checkout___de-DE",
    path: "/checkout",
    meta: indexQrPIrenMTVMeta || {},
    component: () => import("/opt/buildhome/repo/pages/checkout/index.vue")
  },
  {
    name: "checkout-success-id___fr-CH",
    path: "/fr-CH/checkout/success/:id()",
    component: () => import("/opt/buildhome/repo/pages/checkout/success/[id]/index.vue")
  },
  {
    name: "checkout-success-id___de-DE",
    path: "/checkout/success/:id()",
    component: () => import("/opt/buildhome/repo/pages/checkout/success/[id]/index.vue")
  },
  {
    name: "checkout-success-id-paid___fr-CH",
    path: "/fr-CH/checkout/success/:id()/paid",
    component: () => import("/opt/buildhome/repo/pages/checkout/success/[id]/paid.vue")
  },
  {
    name: "checkout-success-id-paid___de-DE",
    path: "/checkout/success/:id()/paid",
    component: () => import("/opt/buildhome/repo/pages/checkout/success/[id]/paid.vue")
  },
  {
    name: "checkout-success-id-unpaid___fr-CH",
    path: "/fr-CH/checkout/success/:id()/unpaid",
    component: () => import("/opt/buildhome/repo/pages/checkout/success/[id]/unpaid.vue")
  },
  {
    name: "checkout-success-id-unpaid___de-DE",
    path: "/checkout/success/:id()/unpaid",
    component: () => import("/opt/buildhome/repo/pages/checkout/success/[id]/unpaid.vue")
  },
  {
    name: "login___fr-CH",
    path: "/fr-CH/login",
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "login___de-DE",
    path: "/login",
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "newsletter-subscribe___fr-CH",
    path: "/fr-CH/newsletter-subscribe",
    component: () => import("/opt/buildhome/repo/pages/newsletter-subscribe.vue")
  },
  {
    name: "newsletter-subscribe___de-DE",
    path: "/newsletter-subscribe",
    component: () => import("/opt/buildhome/repo/pages/newsletter-subscribe.vue")
  },
  {
    name: "register___fr-CH",
    path: "/fr-CH/register",
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "register___de-DE",
    path: "/register",
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "reset-password___fr-CH",
    path: "/fr-CH/reset-password",
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "reset-password___de-DE",
    path: "/reset-password",
    component: () => import("/opt/buildhome/repo/pages/reset-password.vue")
  },
  {
    name: "search___fr-CH",
    path: "/fr-CH/search",
    component: () => import("/opt/buildhome/repo/pages/search.vue")
  },
  {
    name: "search___de-DE",
    path: "/search",
    component: () => import("/opt/buildhome/repo/pages/search.vue")
  },
  {
    name: "shopware___fr-CH",
    path: "/fr-CH/shopware",
    component: () => import("/opt/buildhome/repo/pages/shopware.vue")
  },
  {
    name: "shopware___de-DE",
    path: "/shopware",
    component: () => import("/opt/buildhome/repo/pages/shopware.vue")
  },
  {
    name: "wishlist___fr-CH",
    path: "/fr-CH/wishlist",
    component: () => import("/opt/buildhome/repo/pages/wishlist.vue")
  },
  {
    name: "wishlist___de-DE",
    path: "/wishlist",
    component: () => import("/opt/buildhome/repo/pages/wishlist.vue")
  },
  {
    name: component_45stubGZr1UkTkg3Meta?.name,
    path: "/.well-known/appspecific/:pathMatch(.*)",
    component: component_45stubGZr1UkTkg3
  }
]